/*
 *  ~ Copyright (c) by INFODATA-GROUP. All rights reserved.
 *  ~ No part of this publication may be reproduced, distributed,
 *  ~ or transmitted in any form or by any means, including photocopying, recording,
 *  ~ or other electronic or mechanical methods, without the prior written permission of the publisher,
 *  ~ except in the case of brief quotations embodied in critical
 *  ~ reviews and certain other noncommercial uses permitted by copyright law.
 *  ~ Author : BS
 *  ~ Date : 3/9/23, 5:24 PM
 */

export enum DataEventEnum {
  loadingMenu = 'loadingMenu',
  loadedMenu = 'loadedMenu',
  loadingGmapsTheme = 'loadingGmapsTheme',
  loadedGmapsTheme = 'loadedGmapsTheme',
  allLoaded = 'allLoaded',
  settingsLoaded = 'settingsLoaded',
}
